module.exports = __webpack_public_path__ + "img/hr-tree-08-c-leaves.2891f3fe.png";